var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "2 2 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-1.5 1.5a3.536 3.536 0 01-5 0v0a3.536 3.536 0 010-5l3-3a3.536 3.536 0 015 0v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l1.5-1.5a3.536 3.536 0 015 0v0a3.536 3.536 0 010 5l-3 3a3.536 3.536 0 01-5 0v0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLink);
export default __webpack_public_path__ + "static/media/ico-link.a14366704b391ad382c940badb80eb7f.svg";
export { ForwardRef as ReactComponent };